import { alpha } from '@mui/material/styles';
import palette from './palette';

const color = palette.grey[900];

export default function customShadows() {
  const s = (a) => alpha(color, a);
  return {
    z1: `0 1px 2px 0 ${s(0.05)}`,
    z4: `0 2px 4px -1px ${s(0.06)}, 0 1px 3px 0 ${s(0.04)}`,
    z8: `0 4px 8px -2px ${s(0.08)}, 0 2px 4px -1px ${s(0.04)}`,
    z12: `0 8px 14px -3px ${s(0.10)}, 0 3px 6px -2px ${s(0.04)}`,
    z16: `0 12px 20px -4px ${s(0.10)}, 0 4px 8px -2px ${s(0.04)}`,
    z20: `0 16px 28px -6px ${s(0.12)}, 0 6px 12px -3px ${s(0.04)}`,
    z24: `0 24px 40px -10px ${s(0.14)}, 0 8px 16px -4px ${s(0.04)}`,
    primary: `0 6px 14px -3px ${alpha(palette.primary.main, 0.28)}`,
    info: `0 6px 14px -3px ${alpha(palette.info.main, 0.28)}`,
    secondary: `0 6px 14px -3px ${alpha(palette.secondary.main, 0.28)}`,
    success: `0 6px 14px -3px ${alpha(palette.success.main, 0.28)}`,
    warning: `0 6px 14px -3px ${alpha(palette.warning.main, 0.28)}`,
    error: `0 6px 14px -3px ${alpha(palette.error.main, 0.28)}`,
    card: `0 1px 2px 0 ${s(0.04)}, 0 1px 3px 0 ${s(0.05)}`,
    dialog: `0 24px 48px -12px ${s(0.18)}`,
    dropdown: `0 8px 24px -4px ${s(0.12)}, 0 0 0 1px ${s(0.04)}`,
  };
}
